import ko from 'knockout';
import logger from '../../../Vendor/inv-logger/logger';
import responseRepository from '../../Repositories/responseRepository';

import template from './responseFormLoader.html';

export function ResponseFormLoader(params) {
  const self = this;

  self.params = params;

  self.responseComponentName = null;
  self.areResponseDetailsLoaded = ko.observable(false); // Flags if retrieve response details Ajax request completed

  function getResponseByPublicReference(publicReference) {
    return responseRepository.getResponse(publicReference)
      .then(function (response) {
        self.response = response;
        self.responseComponentName = getResponseFormComponentName(self.response.responseMetadata);

        self.areResponseDetailsLoaded(true);
      })
      .catch(function (jqXhr) {
        logger.logAndThrowUntranslatedError(
          'An error occurred on loading a response. Please try again later.',
          'Unable to get a response',
          jqXhr);
      });
  }

  function getResponseFormComponentName(responseMetaData) {
    const isStandardResponseForm = !responseMetaData.responseFormDefinition;

    if (isStandardResponseForm) {
      return 'response-form';
    }

    return 'custom-response-form';
  }

  getResponseByPublicReference(params.responsePublicReference);
}

export default { viewModel: ResponseFormLoader, template: template };
